import { mutate } from "swr";
import { authenticatedAxios, fetcher } from "lib/actions/fetcher";
import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { AssetModel } from "lib/types/assets/AssetModel";
import { getAssetFromResponse } from "lib/actions/assets/getAssetFromResponse";

export function revertToVersion(id: number, assetId: number) {
  return authenticatedAxios
    .request<void>({
      ...endpointsAssets.versionRevertTo(id),
    })
    .then((_) => {
      const key = endpointsAssets.asset(assetId);
      return mutate<AssetModel>(key, fetcher(key).then(getAssetFromResponse));
    })
    .then((a) => {
      mutate(endpointsAssets.projectAssets(a.projectId));
      mutate(endpointsAssets.asset(assetId));
    });
}
